import React, {FC, ReactNode} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {mainState} from '../AppMainState';
import {AppRoutes} from '../routing/AppRoutes';
import {setTitle} from '../routing/AppRouting';

export interface PrivateRouteProps {
    children?: ReactNode | undefined;
    title: string;
}

export const PrivateRoute: FC<PrivateRouteProps> = (props: any) => {
    const location = useLocation();
    if (mainState.currentUser === undefined) {
        mainState.redirectAfterLogin = location.pathname;
        return <Navigate to={AppRoutes.Login}/>;
    } else {
        setTitle(props.title);
        return props.children ?? <div></div>;
    }
};
